import { Store, Image, Phone, Briefcase, Clock, Search } from 'lucide-react';
import type { RestaurantResponse } from '../types';
import type { OnboardingStep } from './onboardingUtils';

/**
 * Default onboarding steps configuration.
 * This is shared between RestaurantOnboarding and OnboardingGuard.
 */
export const defaultOnboardingSteps: OnboardingStep[] = [
  {
    id: 'basic',
    title: 'Basic Information',
    description: 'Name your restaurant and set your URL',
    icon: Store,
    isRequired: true,
    checkComplete: (r) => !!(r?.name && r.name.length >= 2 && r?.slug && r.slug.length >= 3),
  },
  {
    id: 'media',
    title: 'Branding & Media',
    description: 'Add your logo and theme color',
    icon: Image,
    isRequired: false,
    checkComplete: (r) => !!(r?.logoUrl || r?.themeColor),
  },
  {
    id: 'contact',
    title: 'Contact Information',
    description: 'Phone, email, and location',
    icon: Phone,
    isRequired: true,
    checkComplete: (r) => !!(r?.contactPhone && r?.contactEmail),
  },
  {
    id: 'business',
    title: 'Business Details',
    description: 'Owner details and delivery options',
    icon: Briefcase,
    isRequired: true,
    checkComplete: (r) => !!(r?.ownerName && r?.currency),
  },
  {
    id: 'operations',
    title: 'Hours & Operations',
    description: 'Set your opening hours',
    icon: Clock,
    isRequired: false,
    checkComplete: (r) => !!(r?.openingHours && (Array.isArray(r.openingHours) ? r.openingHours.length > 0 : Object.keys(r.openingHours).length > 0)),
  },
  {
    id: 'seo',
    title: 'SEO Settings',
    description: 'Optimize for search engines',
    icon: Search,
    isRequired: false,
    checkComplete: (r) => !!(r?.seoMetaTitle || r?.seoMetaDescription),
  },
];

